/**
 * Created by d21329
 *
 * axios request config
 */
import {Message} from 'view-design';
import axios from 'axios'

const SWITCH = window.globalConfig.switch
const apiUri = window.globalConfig.apiUri
const uriPrefix = window.globalConfig.forward


let request = {

	//封装axios get接口请求
	getApi(url, successBack, failedBack, exceptionBack) {

		if (SWITCH === false) {
			axios.get(apiUri + uriPrefix + url).then((response) => {
				if (response.code === 1) {
					successBack(response);
				} else {
					failedBack(response);
				}
				})
				.catch((error) => {
					Message.error("网络接口层异常");
					console.error("get interface request exception", error);
					exceptionBack();
				});
		} else {
			let token = sessionStorage.getItem("token");
	
			axios.get(apiUri + uriPrefix + url,
				{
					headers: {
						"X-Requested-With": "XMLHttpRequest",
						Authorization: token,
					},
				})
				.then((response) => {
					sessionStorage.setItem("token", response.headers.token);
	
					if (response.data.code === 1) {
						successBack(response.data);
					} else {
						failedBack(response.data);
					}
				})
				.catch((error) => {
					Message.error("网络接口层异常");
					console.error("get interface request exception", error);
					exceptionBack();
				});
		}
	},

	//封装axios post接口请求
	postApi(url, params, successBack, failedBack, exceptionBack) {

		if (SWITCH === false) {
			axios.post(apiUri + uriPrefix + url, params)
				 .then((response) => {
					if (response.code === 1) {
						successBack(response);
					} else {
						failedBack(response);
					} 
				 })
				 .catch((error) => {
					Message.error("网络接口层异常");
					console.log("post interface request exception", error);
					exceptionBack();
				 });
		} else {
			let token = sessionStorage.getItem("token");
	
			axios.post(apiUri + uriPrefix + url, params, 
				{
					headers: {
						"X-Requested-With": "XMLHttpRequest",
						Authorization: token,
					},
				})
				.then((response) => {
					sessionStorage.setItem("token", response.headers.token);
	
					if (response.data.code === 1) {
						successBack(response.data);
					} else {
						failedBack(response.data);
					}
				})
				.catch((error) => {
					Message.error("网络接口层异常");
					console.error("post interface request exception", error);
					exceptionBack();
				 });
		}
	},


	//封装axios post接口请求
	localPostApi(url, params, auth, successBack, failedBack, exceptionBack) {

		if (SWITCH === false) {
			axios.post(url, params)
				 .then((response) => {
					if (response.code === 1) {
						successBack(response);
					} else {
						failedBack(response);
					} 
				 })
				 .catch((error) => {
					console.error("网络接口层异常");
					console.error("Local post interface request exception", error);
					exceptionBack();
				 });
		} else {
			let token = null;
			if (auth) {
				token = sessionStorage.getItem("token");
			}
	
			axios.post(url, params, 
				{
					headers: {
						"X-Requested-With": "XMLHttpRequest",
						Authorization: token,
					},
				})
				.then((response) => {
					if (auth) {
						sessionStorage.setItem("token", response.headers.token);
					}
	
					if (response.data.code === 1) {
						successBack(response.data);
					} else {
						failedBack(response.data);
					}
				})
				.catch((error) => {
					console.error("网络接口层异常");
					console.error("Local post interface request exception", error);
					exceptionBack();
				 });
		}
	},

	//封装axios put接口请求
	putApi(url, params, successBack, failedBack, exceptionBack) {

		if (SWITCH === false) {
			axios.put(apiUri + uriPrefix + url, params)
				 .then((response) => {
					if (response.code === 1) {
						successBack(response);
					} else {
						failedBack(response);
					} 
				 })
				 .catch((error) => {
					Message.error("网络接口层异常");
					console.error("put interface request exception", error);
					exceptionBack();
				 });
		} else {
			let token = sessionStorage.getItem("token");
	
			axios.put(apiUri + uriPrefix + url, params, 
				{
					headers: {
						"X-Requested-With": "XMLHttpRequest",
						Authorization: token,
					},
				})
				.then((response) => {
					sessionStorage.setItem("token", response.headers.token);
	
					if (response.data.code === 1) {
						successBack(response.data);
					} else {
						failedBack(response.data);
					}
				})
				.catch((error) => {
					Message.error("网络接口层异常");
					console.error("put interface request exception", error);
					exceptionBack();
				 });
		}
	},

	//封装axios delete接口请求
	deleteApi(url, successBack, failedBack, exceptionBack) {

		if (SWITCH === false) {
			axios.delete(apiUri + uriPrefix + url).then((response) => {
				if (response.code === 1) {
					successBack(response);
				} else {
					failedBack(response);
				}
				})
				.catch((error) => {
					Message.error("网络接口层异常");
					console.error("delete interface request exception", error);
					exceptionBack();
				});
		} else {
			let token = sessionStorage.getItem("token");
	
			axios.delete(apiUri + uriPrefix + url,
				{
					headers: {
						"X-Requested-With": "XMLHttpRequest",
						Authorization: token,
					},
				})
				.then((response) => {
					sessionStorage.setItem("token", response.headers.token);
	
					if (response.data.code === 1) {
						successBack(response.data);
					} else {
						failedBack(response.data);
					}
				})
				.catch((error) => {
					Message.error("网络接口层异常");
					console.error("delete interface request exception", error);
					exceptionBack();
				});
		}
	},


}; 


export default request



// WEBPACK FOOTER //
// ./src/views/diagnose/request.js